export default __webpack_public_path__ + "static/media/jetski.d6946b46.svg";